import{jsx as _jsx}from"react/jsx-runtime";import{ruiTWMerge}from"../helpers/ruiTWMerge.js";import{defaultHeadingStyles}from"./style.js";/**
 * A styled heading element.
 *
 * @param props The HTML props for the heading element.
 * @returns A styled heading element.
 */export const Heading6=props=>{const{className:extendedClassName,...rest}=props;const className=ruiTWMerge(defaultHeadingStyles,extendedClassName);return /*#__PURE__*/_jsx("h6",{"data-component-type":"Heading6",...rest,className:className})};